module.exports = __webpack_public_path__ + "static/media/right_label.b591b69e.svg";